var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_2010",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12C7.22241 12.0009 7.93788 11.8591 8.60529 11.5826C9.2727 11.3062 9.8789 10.9005 10.389 10.389C10.9005 9.8789 11.3062 9.2727 11.5826 8.60529C11.8591 7.93788 12.0009 7.22241 12 6.5C12.0009 5.7776 11.8591 5.06213 11.5826 4.39472C11.3062 3.72731 10.9005 3.12111 10.389 2.61095C9.8789 2.09946 9.2727 1.69383 8.60529 1.41737C7.93788 1.14091 7.22241 0.999069 6.5 1C5.7776 0.999084 5.06213 1.14093 4.39472 1.41739C3.72731 1.69385 3.12111 2.09947 2.61095 2.61095C2.09947 3.12111 1.69385 3.72731 1.41739 4.39472C1.14093 5.06213 0.999084 5.7776 1 6.5C0.999069 7.22241 1.14091 7.93788 1.41737 8.60529C1.69383 9.2727 2.09946 9.8789 2.61095 10.389C3.12111 10.9005 3.72731 11.3062 4.39472 11.5826C5.06213 11.8591 5.7776 12.0009 6.5 12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2998 6.49961L5.9498 8.14961L9.2498 4.84961",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_2010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2 -2H15V15H-2V-2Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.e8b51c8d080deb92df6c55707747f576.svg";
export { ForwardRef as ReactComponent };